import * as React from 'react';

const companyContext: { id: number | null } = { id: null };

export default React.createContext(companyContext);
